import { render, staticRenderFns } from "./PublishedProperties.vue?vue&type=template&id=cb7a1242&scoped=true&"
import script from "./PublishedProperties.vue?vue&type=script&lang=js&"
export * from "./PublishedProperties.vue?vue&type=script&lang=js&"
import style0 from "./PublishedProperties.vue?vue&type=style&index=0&id=cb7a1242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7a1242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable,VSnackbar})
